import * as React from "react"

export default function SortIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.167 3.834v10h1.96L15.833 16.7l-2.293-2.866h1.96v-10h.667zM9.5 15.501v.666H3v-.666h6.5zm1.667-5.834v.667H3v-.667h8.167zm0-5.833v.667H3v-.667h8.167z"
        fill={props.fill}
        stroke={props.fill}
      />
    </svg>
  )
}
